import { TagRequest } from '~src/httpClient/TAG/TagRequest';

import { ITagResult } from '../../../httpClient/serverApi/types/IResponse';
import { IAnalyticsConnectionMapping } from '../../../settings/types/ISiteSettingsForSiteAdmin';

export type ISetAnalyticsExtConnectionForWorkbookResult = ITagResult;

export class SetAnalyticsExtConnectionForWorkbookRequest extends TagRequest<IAnalyticsConnectionMapping, ISetAnalyticsExtConnectionForWorkbookResult> {
  constructor(params: IAnalyticsConnectionMapping) {
    super('analyticsextensions', 'updateWorkbookWithConnection', params);
  }
}
